export const TEST_ID_GALLERY_BASIC_WRAPPER = 'gallery-basic-wrapper'
export const TEST_ID_MAIN_SLIDER = 'gallery-basic-main-slider'
export const TEST_ID_THUMBNAILS_SLIDER = 'gallery-basic-thumbnails-slider'

export const BASE_CLASS = 'mt-GalleryBasic'
export const SLIDER_BASE_CLASS = `${BASE_CLASS}-slider`
export const ITEMS_LIST_CLASS = `${BASE_CLASS}-itemsList`
export const SLIDER_WIDE_CLASS_MODIFIER = `${BASE_CLASS}-slider--wide`
export const SLIDER_WRAPPER_CLASS = `${SLIDER_BASE_CLASS}Wrapper`
export const SLIDER_IMAGE_BASE_CLASS = `${SLIDER_BASE_CLASS}Image`
export const SLIDER_VIDEO_BASE_CLASS = `${SLIDER_IMAGE_BASE_CLASS} ${SLIDER_IMAGE_BASE_CLASS}Video`
export const SLIDER_IMAGE_SINGLE_CLASS = `${SLIDER_IMAGE_BASE_CLASS}--single`
export const SLIDER_IMAGE_WIDE_CLASS = `${SLIDER_IMAGE_BASE_CLASS}--wide`
export const THUMBNAIL_CLASS = `${BASE_CLASS}-thumbnail`
export const THUMBNAIL_IMAGE_CLASS = `${THUMBNAIL_CLASS}Image`
export const THUMBNAILS_WRAPPER_CLASS = `${BASE_CLASS}-thumbnailsWrapper`
export const THUMBNAILS_WRAPPER_SKELETON_CLASS = `${THUMBNAILS_WRAPPER_CLASS}Skeleton`
export const TAG_CHIPS_CLASS = `${BASE_CLASS}-tags`
export const BADGES_CLASS = `${BASE_CLASS}-badges`
export const FULL_SIZE_ACTION_BUTTON_CLASS = `${BASE_CLASS}-fullSizeActionBtn`

export const ASPECT_RATIO = 1.33

export const THUMBNAIL_WIDTH = 95

export const DEFAULT_NUMBER_OF_THUMBNAILS = 7
export const THUMBNAIL_IMAGE_SIZE = '/95X71cut/'
export const THUMBNAILS_WRAPPER_SKELETON_STYLES = {
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  height: '100%'
}

export const SLIDER_IMAGE_SIZES = {
  EXTRA_LARGE: 'extraLarge', // example for News detail gallery
  LARGE: 'large', // example for AdsList cards
  MEDIUM_UNIQUE: 'mediumUnique', // example for medium unique use case
  SMALL: 'small' // example for AdDetails gallery
}

export const SLIDER_IMAGE_SIZE_CONFIG = {
  [SLIDER_IMAGE_SIZES.EXTRA_LARGE]: {desktop: 1200, mobile: 768}, // example for News detail gallery
  [SLIDER_IMAGE_SIZES.LARGE]: {desktop: 712, mobile: 560}, // example for AdDetails gallery
  [SLIDER_IMAGE_SIZES.MEDIUM_UNIQUE]: {desktop: 500, mobile: 500}, // example for medium unique use case
  [SLIDER_IMAGE_SIZES.SMALL]: {desktop: 252, mobile: 560} // example for AdsList cards,
}

export const SLIDER_OPTIONS = {
  classNameBase: BASE_CLASS,
  hasInfiniteLoop: true,
  hasKeyboardNavigation: false,
  imageObjectFit: 'contain',
  isFullWidth: true
}

export const DEFAULT_THUMBNAILS_SLIDER_OPTIONS = {
  classNameBase: BASE_CLASS,
  hasArrows: false,
  isFullHeight: true,
  isFullWidth: false,
  isSanitized: false,
  numOfSlides: DEFAULT_NUMBER_OF_THUMBNAILS
}

export const SLIDER_IMAGE_DESIGNS = {
  rounded: 'rounded',
  squared: 'squared'
}

export const COUNTER_POSITIONS = {
  bottomCenter: 'bottomCenter',
  bottomLeft: 'bottomLeft'
}

export const FULL_SIZE_BUTTON_POSITIONS = {
  topRight: 'topRight',
  bottomRight: 'bottomRight'
}

export const GALLERY_CLICKED_EVENT_NAME = 'Detail Gallery Clicked'

export const GALLERY_ASPECT_RATIO = {
  fullScreen: 'FULL_SCREEN',
  wideScreen: 'WIDE_SCREEN'
}
// Videos config 👇🏽
export const INTERSECTION_OBSERVER_CONFIGURATION = {
  root: null,
  rootMargin: '0% 0% 0% 0%'
}

export const NO_OP = () => null
